import React, { Component } from 'react'
import PropTypes from 'prop-types';
import './index.scss';
import ContentLoader from "react-content-loader";

class LoadingContent extends Component {
  constructor() {
    super()
    this.preventFn = this.preventFn.bind(this)
  }
  componentDidMount() {
    document.querySelector('.loadingContent').addEventListener('touchmove', this.preventFn)
  }

  componentWillUnmount() {
    document.querySelector('.loadingContent').removeEventListener('touchmove', this.preventFn)
  }

  preventFn(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className='loadingContent'>
        {/* <ContentLoader height={860} speed={.6}>
                    <rect x="0" y="0" rx="5" ry="5" width="400" height="220" />
                
                    <rect x='10' y='240' rx='5' ry='5' width='370' height='10' />  
                    <rect x='10' y='260' rx='5' ry='5' width='200' height='10' />  

                    <rect x='10' y='300' rx='20' ry='20' width='40' height='40' />
                    <rect x='60' y='310' rx='10' ry='10' width='120' height='20' />
                    
                    <rect x='10' y='360' rx='5' ry='5' width='370' height='10' />
                    <rect x='10' y='380' rx='5' ry='5' width='370' height='10' />
                    <rect x='10' y='400' rx='5' ry='5' width='300' height='10' />

                    <rect x="10" y="440" rx="5" ry="5" width="375" height="220" />
                </ContentLoader>     */}
        <div className="sk-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
          <div className="loadingText">
            loading....
          </div>
        </div>
      </div>
    )
  }
}
export default LoadingContent